import axios from 'axios';
import { RouteData, RouteQueryParams, PaginatedRouteResponse } from '../types/route';

const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

export const getRoutes = async (params: RouteQueryParams, token: string): Promise<PaginatedRouteResponse | RouteData[]> => {
  try {
    const url = new URL(`${API_BASE_URL}/api/v2/route/getRoutes`);
    
    // Only add shipmentNumber if provided
    if (params.shipmentNumber && params.shipmentNumber.trim()) {
      url.searchParams.append('shipmentNumber', params.shipmentNumber);
    }
    
    // Only add serialNumber if provided
    if (params.serialNumber && params.serialNumber.trim()) {
      url.searchParams.append('serialNumber', params.serialNumber);
    }
    
    // Add pagination parameters with defaults
    url.searchParams.append('page', (params.page ?? 0).toString());
    url.searchParams.append('size', (params.size ?? 50).toString());
    url.searchParams.append('sortBy', params.sortBy ?? 'id');
    url.searchParams.append('sortDir', params.sortDir ?? 'asc');

    const response = await axios.get(url.toString(), {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      // Return empty paginated response for no results
      return {
        content: [],
        pagination: {
          currentPage: params.page ?? 0,
          totalPages: 0,
          totalItems: 0,
          pageSize: params.size ?? 50,
          hasNext: false,
          hasPrevious: false,
        }
      };
    }
    if (error.response?.status === 401) {
      throw new Error('Authentication required');
    }
    if (error.response?.status === 403) {
      throw new Error('Access denied');
    }
    throw new Error('Failed to fetch routes');
  }
}; 